import * as React from 'react';
import * as styles from './styles.css';

import { IValuationFiltersProps } from '../../types';
import { TRefWrapper } from '../../../../containers/Scrolling';

export interface IValuationFilterMobileProps extends Partial<IValuationFiltersProps> {
  refWrapper: TRefWrapper;
}

export const ValuationFiltersMobile: React.FC<IValuationFilterMobileProps> = ({
  mainFiltersWidget,
  valuationFiltersSubmit,
  heroBanner,
  refWrapper,
}) => {
  return refWrapper(
    <div data-testid="ValuationFiltersMobile" className={styles['container']}>
      {heroBanner}
      <div className={styles['filters']}>{mainFiltersWidget}</div>
      {valuationFiltersSubmit}
    </div>,
  );
};

ValuationFiltersMobile.displayName = 'ValuationFiltersMobile';
